// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  height: 100%;
}

.font-size-1 {
  font-size: 1px !important;
}

.font-size-2 {
  font-size: 2px !important;
}

.font-size-3 {
  font-size: 3px !important;
}

.font-size-4 {
  font-size: 4px !important;
}

.font-size-5 {
  font-size: 5px !important;
}

.font-size-6 {
  font-size: 6px !important;
}

.font-size-7 {
  font-size: 7px !important;
}

.font-size-8 {
  font-size: 8px !important;
}

.font-size-9 {
  font-size: 9px !important;
}

.font-size-10 {
  font-size: 10px !important;
}

.font-size-11 {
  font-size: 11px !important;
}

.font-size-12 {
  font-size: 12px !important;
}

.font-size-13 {
  font-size: 13px !important;
}

.font-size-14 {
  font-size: 14px !important;
}

.font-size-15 {
  font-size: 15px !important;
}

.font-size-16 {
  font-size: 16px !important;
}

.font-size-17 {
  font-size: 17px !important;
}

.font-size-18 {
  font-size: 18px !important;
}

.font-size-19 {
  font-size: 19px !important;
}

.font-size-20 {
  font-size: 20px !important;
}

.font-size-21 {
  font-size: 21px !important;
}

.font-size-22 {
  font-size: 22px !important;
}

.font-size-23 {
  font-size: 23px !important;
}

.font-size-24 {
  font-size: 24px !important;
}

.font-size-25 {
  font-size: 25px !important;
}

.font-size-26 {
  font-size: 26px !important;
}

.font-size-27 {
  font-size: 27px !important;
}

.font-size-28 {
  font-size: 28px !important;
}

.font-size-29 {
  font-size: 29px !important;
}

.font-size-30 {
  font-size: 30px !important;
}

.font-size-31 {
  font-size: 31px !important;
}

.font-size-32 {
  font-size: 32px !important;
}

.font-size-33 {
  font-size: 33px !important;
}

.font-size-34 {
  font-size: 34px !important;
}

.font-size-35 {
  font-size: 35px !important;
}

.font-size-36 {
  font-size: 36px !important;
}

.font-size-37 {
  font-size: 37px !important;
}

.font-size-38 {
  font-size: 38px !important;
}

.font-size-39 {
  font-size: 39px !important;
}

.font-size-40 {
  font-size: 40px !important;
}

.font-size-41 {
  font-size: 41px !important;
}

.font-size-42 {
  font-size: 42px !important;
}

.font-size-43 {
  font-size: 43px !important;
}

.font-size-44 {
  font-size: 44px !important;
}

.font-size-45 {
  font-size: 45px !important;
}

.font-size-46 {
  font-size: 46px !important;
}

.font-size-47 {
  font-size: 47px !important;
}

.font-size-48 {
  font-size: 48px !important;
}

.font-size-49 {
  font-size: 49px !important;
}

.font-size-50 {
  font-size: 50px !important;
}

.font-size-51 {
  font-size: 51px !important;
}

.font-size-52 {
  font-size: 52px !important;
}

.font-size-53 {
  font-size: 53px !important;
}

.font-size-54 {
  font-size: 54px !important;
}

.font-size-55 {
  font-size: 55px !important;
}

.font-size-56 {
  font-size: 56px !important;
}

.font-size-57 {
  font-size: 57px !important;
}

.font-size-58 {
  font-size: 58px !important;
}

.font-size-59 {
  font-size: 59px !important;
}

.font-size-60 {
  font-size: 60px !important;
}

.font-size-61 {
  font-size: 61px !important;
}

.font-size-62 {
  font-size: 62px !important;
}

.font-size-63 {
  font-size: 63px !important;
}

.font-size-64 {
  font-size: 64px !important;
}

.font-size-65 {
  font-size: 65px !important;
}

.font-size-66 {
  font-size: 66px !important;
}

.font-size-67 {
  font-size: 67px !important;
}

.font-size-68 {
  font-size: 68px !important;
}

.font-size-69 {
  font-size: 69px !important;
}

.font-size-70 {
  font-size: 70px !important;
}

.font-size-71 {
  font-size: 71px !important;
}

.font-size-72 {
  font-size: 72px !important;
}

.font-size-73 {
  font-size: 73px !important;
}

.font-size-74 {
  font-size: 74px !important;
}

.font-size-75 {
  font-size: 75px !important;
}

.font-size-76 {
  font-size: 76px !important;
}

.font-size-77 {
  font-size: 77px !important;
}

.font-size-78 {
  font-size: 78px !important;
}

.font-size-79 {
  font-size: 79px !important;
}

.font-size-80 {
  font-size: 80px !important;
}

.font-size-81 {
  font-size: 81px !important;
}

.font-size-82 {
  font-size: 82px !important;
}

.font-size-83 {
  font-size: 83px !important;
}

.font-size-84 {
  font-size: 84px !important;
}

.font-size-85 {
  font-size: 85px !important;
}

.font-size-86 {
  font-size: 86px !important;
}

.font-size-87 {
  font-size: 87px !important;
}

.font-size-88 {
  font-size: 88px !important;
}

.font-size-89 {
  font-size: 89px !important;
}

.font-size-90 {
  font-size: 90px !important;
}

.font-size-91 {
  font-size: 91px !important;
}

.font-size-92 {
  font-size: 92px !important;
}

.font-size-93 {
  font-size: 93px !important;
}

.font-size-94 {
  font-size: 94px !important;
}

.font-size-95 {
  font-size: 95px !important;
}

.font-size-96 {
  font-size: 96px !important;
}

.font-size-97 {
  font-size: 97px !important;
}

.font-size-98 {
  font-size: 98px !important;
}

.font-size-99 {
  font-size: 99px !important;
}

.font-size-100 {
  font-size: 100px !important;
}

body {
  margin: 0;
  font-family: "roboto" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: hsl(0, 0%, 92%) !important;
  color: hsl(217, 24%, 17%) !important;
}

a {
  color: hsl(240, 91%, 69%);
}
a:hover, a:focus {
  color: hsl(240, 91%, 69%);
}
a.no-underline {
  text-decoration: none;
}

.cursor-pointer {
  cursor: pointer;
}

.gate__menu .MuiPaper-root {
  border-radius: 5px;
  box-shadow: 0px 2px 2px rgba(76, 79, 83, 0.14);
  box-sizing: border-box;
  margin-top: -8px;
  margin-left: 10px;
}
.gate__menu .MuiList-root {
  padding: 0 16px;
  background: #F8F8F9;
  border-radius: 5px;
}
.gate__menu .MuiList-root .MuiMenuItem-root {
  color: hsl(214, 4%, 39%);
  font-size: 14px;
  letter-spacing: 0.25px;
  justify-content: center;
  line-height: 1;
  padding: 6px 0;
}
.gate__menu .MuiList-root .MuiMenuItem-root:not(:last-child) {
  border-bottom: 1px solid rgba(196, 196, 196, 0.2);
}

.gates__list {
  margin-bottom: 32px;
}
.gates__list__header {
  font-size: 18px;
  font-weight: 900;
  margin-bottom: 12px;
  text-transform: capitalize;
}
.gates__list__body .table-responsive {
  border-radius: 5px 5px 0 0;
}
.gates__list__body .pagination {
  justify-content: center;
  margin-top: 2rem;
}
.gates__list__body .pagination .page-item {
  margin: 0 4px;
}
.gates__list__body .pagination .page-item.active a {
  color: #4C4F53;
}
.gates__list__body .pagination .page-item .page-link {
  background: transparent;
  border: 0;
  padding: 4px 8px;
  color: #0d6efd;
}
.gates__list__body .pagination .page-item .page-link .rightPagination__arrow path, .gates__list__body .pagination .page-item .page-link .leftPagination__arrow path {
  fill: #0d6efd;
}
.gates__list__body .pagination .page-item:first-child .page-link, .gates__list__body .pagination .page-item:last-child .page-link {
  background: #FDFDFD;
  border-radius: 5px;
}
.gates__list__body .pagination .page-item.disabled .rightPagination__arrow path, .gates__list__body .pagination .page-item.disabled .leftPagination__arrow path {
  fill: #EAEAEA;
}
.gates__list__body-table {
  margin-bottom: 0;
}
.gates__list__body-table tr {
  border-bottom: solid 0.2em hsla(213, 7%, 76%, 0.08);
}
.gates__list__body-table tbody tr:hover {
  background-color: hsla(237, 69%, 40%, 0.06);
}
.gates__list__body-table .body__header {
  background: hsla(213, 7%, 76%, 0.08);
  border-radius: 5px 5px 0px 0px;
}
.gates__list__body-table .table__body tr {
  background: #FDFDFD;
  border: 1px solid rgba(73, 68, 84, 0.06);
}
.gates__list__body-table .table__body tr:nth-child(even) {
  background: #FAFAFA;
  border: 1px solid rgba(73, 68, 84, 0.06);
}
.gates__list__body-table .table__body tr:nth-child(even):hover {
  background-color: hsla(237, 69%, 40%, 0.06);
}
.gates__list__body-table .table__body td {
  padding-bottom: 17px;
  padding-top: 17px;
  height: 70px;
}
.gates__list__body-table-header {
  padding: 19px 8px 16px !important;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.15px;
  color: hsl(214, 4%, 31%);
  border: none;
}
.gates__list__body-table-header:first-child {
  padding-left: 44px !important;
}
.gates__list__body-table-header:last-child {
  padding-left: 0;
  padding-right: 0;
}
.gates__list__body-row {
  font-size: 12px;
  cursor: pointer;
}
.gates__list__body-row.draft td:not(:last-of-type) {
  width: 10%;
}
.gates__list__body-row.draft td:first-child {
  width: 60%;
  word-break: break-all;
}
.gates__list__body-row.draft td:nth-of-type(5) {
  width: 6%;
}
.gates__list__body-row.draft td:last-of-type {
  width: 1%;
}
@media screen and (max-width: 1280px) {
  .gates__list__body-row.draft td {
    width: 15%;
  }
  .gates__list__body-row.draft td:first-child {
    width: 60%;
  }
}
.gates__list__body-row.running td:not(:last-of-type) {
  width: 9.5%;
}
.gates__list__body-row.running td:first-child {
  width: 50%;
  word-break: break-all;
}
.gates__list__body-row.running td:nth-of-type(6) {
  width: 8%;
}
.gates__list__body-row.running td:last-of-type {
  width: 1%;
}
@media screen and (max-width: 1280px) {
  .gates__list__body-row.running td {
    width: 15%;
  }
  .gates__list__body-row.running td:first-child {
    width: 40%;
  }
}
.gates__list__body-row.paused td:not(:last-of-type), .gates__list__body-row.archived td:not(:last-of-type) {
  width: 9.5%;
}
.gates__list__body-row.paused td:first-child, .gates__list__body-row.archived td:first-child {
  width: 50%;
  word-break: break-all;
}
.gates__list__body-row.paused td:nth-of-type(6), .gates__list__body-row.archived td:nth-of-type(6) {
  width: 8%;
}
.gates__list__body-row.paused td:last-of-type, .gates__list__body-row.archived td:last-of-type {
  width: 1%;
}
@media screen and (max-width: 1280px) {
  .gates__list__body-row.paused td, .gates__list__body-row.archived td {
    width: 15%;
  }
  .gates__list__body-row.paused td:first-child, .gates__list__body-row.archived td:first-child {
    width: 40%;
  }
}
.gates__list__body-row.all td:not(:last-of-type) {
  width: 10%;
}
.gates__list__body-row.all td:first-child {
  width: 50%;
  word-break: break-all;
}
.gates__list__body-row.all td:nth-of-type(6) {
  width: 6%;
}
.gates__list__body-row.all td:last-of-type {
  width: 1%;
}
@media screen and (max-width: 1280px) {
  .gates__list__body-row.all td {
    width: 15%;
  }
  .gates__list__body-row.all td:first-child {
    width: 55%;
  }
}
.gates__list__body-row button svg {
  color: #000;
  height: 18px;
}
.gates__list__body-row td {
  border: none;
  vertical-align: middle;
}
.gates__list__body-row td .button_container {
  display: flex;
  align-items: center;
}
.gates__list__body-row td .button_container.status_color {
  font-weight: 700;
  text-transform: capitalize;
  color: rgba(73, 68, 84, 0.5);
  word-break: inherit;
}
.gates__list__body-row td .button_container button {
  padding: 14px;
}
.gates__list__body-row td .button_container p {
  margin-bottom: 0;
  font-size: 12px;
  font-weight: 400;
}
.gates__list__body-row td:first-child {
  padding-left: 0;
}`, "",{"version":3,"sources":["webpack://./src/index.scss","webpack://./src/components/list/gates/gates.scss"],"names":[],"mappings":"AAyDA;;EAEE,YAAA;ACvDF;;AD6DE;EACI,yBAAA;AC1DN;;ADyDE;EACI,yBAAA;ACtDN;;ADqDE;EACI,yBAAA;AClDN;;ADiDE;EACI,yBAAA;AC9CN;;AD6CE;EACI,yBAAA;AC1CN;;ADyCE;EACI,yBAAA;ACtCN;;ADqCE;EACI,yBAAA;AClCN;;ADiCE;EACI,yBAAA;AC9BN;;AD6BE;EACI,yBAAA;AC1BN;;ADyBE;EACI,0BAAA;ACtBN;;ADqBE;EACI,0BAAA;AClBN;;ADiBE;EACI,0BAAA;ACdN;;ADaE;EACI,0BAAA;ACVN;;ADSE;EACI,0BAAA;ACNN;;ADKE;EACI,0BAAA;ACFN;;ADCE;EACI,0BAAA;ACEN;;ADHE;EACI,0BAAA;ACMN;;ADPE;EACI,0BAAA;ACUN;;ADXE;EACI,0BAAA;ACcN;;ADfE;EACI,0BAAA;ACkBN;;ADnBE;EACI,0BAAA;ACsBN;;ADvBE;EACI,0BAAA;AC0BN;;AD3BE;EACI,0BAAA;AC8BN;;AD/BE;EACI,0BAAA;ACkCN;;ADnCE;EACI,0BAAA;ACsCN;;ADvCE;EACI,0BAAA;AC0CN;;AD3CE;EACI,0BAAA;AC8CN;;AD/CE;EACI,0BAAA;ACkDN;;ADnDE;EACI,0BAAA;ACsDN;;ADvDE;EACI,0BAAA;AC0DN;;AD3DE;EACI,0BAAA;AC8DN;;AD/DE;EACI,0BAAA;ACkEN;;ADnEE;EACI,0BAAA;ACsEN;;ADvEE;EACI,0BAAA;AC0EN;;AD3EE;EACI,0BAAA;AC8EN;;AD/EE;EACI,0BAAA;ACkFN;;ADnFE;EACI,0BAAA;ACsFN;;ADvFE;EACI,0BAAA;AC0FN;;AD3FE;EACI,0BAAA;AC8FN;;AD/FE;EACI,0BAAA;ACkGN;;ADnGE;EACI,0BAAA;ACsGN;;ADvGE;EACI,0BAAA;AC0GN;;AD3GE;EACI,0BAAA;AC8GN;;AD/GE;EACI,0BAAA;ACkHN;;ADnHE;EACI,0BAAA;ACsHN;;ADvHE;EACI,0BAAA;AC0HN;;AD3HE;EACI,0BAAA;AC8HN;;AD/HE;EACI,0BAAA;ACkIN;;ADnIE;EACI,0BAAA;ACsIN;;ADvIE;EACI,0BAAA;AC0IN;;AD3IE;EACI,0BAAA;AC8IN;;AD/IE;EACI,0BAAA;ACkJN;;ADnJE;EACI,0BAAA;ACsJN;;ADvJE;EACI,0BAAA;AC0JN;;AD3JE;EACI,0BAAA;AC8JN;;AD/JE;EACI,0BAAA;ACkKN;;ADnKE;EACI,0BAAA;ACsKN;;ADvKE;EACI,0BAAA;AC0KN;;AD3KE;EACI,0BAAA;AC8KN;;AD/KE;EACI,0BAAA;ACkLN;;ADnLE;EACI,0BAAA;ACsLN;;ADvLE;EACI,0BAAA;AC0LN;;AD3LE;EACI,0BAAA;AC8LN;;AD/LE;EACI,0BAAA;ACkMN;;ADnME;EACI,0BAAA;ACsMN;;ADvME;EACI,0BAAA;AC0MN;;AD3ME;EACI,0BAAA;AC8MN;;AD/ME;EACI,0BAAA;ACkNN;;ADnNE;EACI,0BAAA;ACsNN;;ADvNE;EACI,0BAAA;AC0NN;;AD3NE;EACI,0BAAA;AC8NN;;AD/NE;EACI,0BAAA;ACkON;;ADnOE;EACI,0BAAA;ACsON;;ADvOE;EACI,0BAAA;AC0ON;;AD3OE;EACI,0BAAA;AC8ON;;AD/OE;EACI,0BAAA;ACkPN;;ADnPE;EACI,0BAAA;ACsPN;;ADvPE;EACI,0BAAA;AC0PN;;AD3PE;EACI,0BAAA;AC8PN;;AD/PE;EACI,0BAAA;ACkQN;;ADnQE;EACI,0BAAA;ACsQN;;ADvQE;EACI,0BAAA;AC0QN;;AD3QE;EACI,0BAAA;AC8QN;;AD/QE;EACI,0BAAA;ACkRN;;ADnRE;EACI,0BAAA;ACsRN;;ADvRE;EACI,0BAAA;AC0RN;;AD3RE;EACI,0BAAA;AC8RN;;AD/RE;EACI,0BAAA;ACkSN;;ADnSE;EACI,0BAAA;ACsSN;;ADvSE;EACI,0BAAA;AC0SN;;AD3SE;EACI,0BAAA;AC8SN;;AD/SE;EACI,0BAAA;ACkTN;;ADnTE;EACI,0BAAA;ACsTN;;ADvTE;EACI,0BAAA;AC0TN;;AD3TE;EACI,0BAAA;AC8TN;;AD/TE;EACI,0BAAA;ACkUN;;ADnUE;EACI,0BAAA;ACsUN;;ADvUE;EACI,0BAAA;AC0UN;;AD3UE;EACI,0BAAA;AC8UN;;AD/UE;EACI,2BAAA;ACkVN;;AD9UA;EACE,SAAA;EACA,gCAAA;EACA,mCAAA;EACA,kCAAA;EACA,4CAAA;EACA,oCAAA;ACiVF;;AD9UA;EACE,yBA9Ca;AC+Xf;AD/UE;EAEE,yBAnDW;ACmYf;AD7UE;EACE,qBAAA;AC+UJ;;AD3UA;EACE,eAAA;AC8UF;;AAxaI;EACI,kBAAA;EACA,8CAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;AA2aR;AAxaI;EACI,eAAA;EACA,mBAAA;EACA,kBAAA;AA0aR;AAxaQ;EACI,wBDUG;ECTH,eAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;AA0aZ;AAzaY;EACI,iDAAA;AA2ahB;;AAraA;EACI,mBAAA;AAwaJ;AAtaI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;AAwaR;AApaQ;EACI,0BAAA;AAsaZ;AAhaQ;EACI,uBAAA;EACA,gBAAA;AAkaZ;AAjaY;EACI,aAAA;AAmahB;AAjaoB;EACI,cAAA;AAmaxB;AAhagB;EACI,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,cAAA;AAkapB;AAhawB;EACI,aAAA;AAka5B;AA9ZgB;EACI,mBAAA;EACA,kBAAA;AAgapB;AA5ZwB;EACI,aAAA;AA8Z5B;AAtZI;EACI,gBAAA;AAwZR;AAtZQ;EACI,mDAAA;AAwZZ;AApZY;EACI,2CAAA;AAsZhB;AAnZQ;EACI,oCD7CA;EC8CA,8BAAA;AAqZZ;AAlZY;EACI,mBAAA;EACA,wCAAA;AAoZhB;AAlZY;EACI,mBAAA;EACA,wCAAA;AAoZhB;AAnZgB;EACI,2CAAA;AAqZpB;AAlZY;EACI,oBAAA;EACA,iBAAA;EACA,YAAA;AAoZhB;AA/YI;EACI,iCAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,wBDxFO;ECyFP,YAAA;AAiZR;AA/YQ;EACI,6BAAA;AAiZZ;AA9YQ;EACI,eAAA;EACA,gBAAA;AAgZZ;AA5YI;EACI,eAAA;EAEA,eAAA;AA6YR;AA1YY;EACI,UAAA;AA4YhB;AAzYY;EACI,UAAA;EACA,qBAAA;AA2YhB;AAzYY;EACI,SAAA;AA2YhB;AAzYY;EACI,SAAA;AA2YhB;AAxYY;EAhBJ;IAiBQ,UAAA;EA2Yd;EAzYc;IACI,UAAA;EA2YlB;AACF;AAtYY;EACI,WAAA;AAwYhB;AArYY;EACI,UAAA;EACA,qBAAA;AAuYhB;AArYY;EACI,SAAA;AAuYhB;AArYY;EACI,SAAA;AAuYhB;AApYY;EAhBJ;IAiBQ,UAAA;EAuYd;EArYc;IACI,UAAA;EAuYlB;AACF;AAjYY;EACI,WAAA;AAmYhB;AAhYY;EACI,UAAA;EACA,qBAAA;AAkYhB;AAhYY;EACI,SAAA;AAkYhB;AAhYY;EACI,SAAA;AAkYhB;AA/XY;EAjBJ;IAkBQ,UAAA;EAkYd;EAhYc;IACI,UAAA;EAkYlB;AACF;AA7XY;EACI,UAAA;AA+XhB;AA5XY;EACI,UAAA;EACA,qBAAA;AA8XhB;AA5XY;EACI,SAAA;AA8XhB;AA5XY;EACI,SAAA;AA8XhB;AA1XY;EAjBJ;IAkBQ,UAAA;EA6Xd;EA3Xc;IACI,UAAA;EA6XlB;AACF;AAzXQ;EACI,WAAA;EACA,YAAA;AA2XZ;AAvXI;EACI,YAAA;EACA,sBAAA;AAyXR;AAvXQ;EACI,aAAA;EACA,mBAAA;AAyXZ;AAxXY;EACI,gBAAA;EACA,0BAAA;EACA,4BAAA;EACA,mBAAA;AA0XhB;AAxXY;EACI,aAAA;AA0XhB;AAxXY;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;AA0XhB;AAtXQ;EACI,eAAA;AAwXZ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');\n$clr-danger-900: hsla(0, 89%, 48%, 0.19);\n$clr-danger-450: hsla(5, 99%, 64%, 1);\n$clr-danger-400: hsla(5, 100%, 69%, 1);\n$clr-danger-200: hsla(0, 48%, 83%, 1);\n$clr-primary-900: hsla(237, 69%, 40%, 1);\n$clr-primary-700: hsla(237, 69%, 52%, 1);\n$clr-primary-600: hsla(233, 100%, 57%, 1);\n$clr-primary-400: hsla(237, 40%, 67%, 1);\n$clr-primary-300: hsla(237, 46%, 75%, 1);\n$clr-light-350: hsla(0, 0%, 77%, 0.44);\n$clr-light-450: hsla(0, 0%, 85%, 1);\n$clr-light-500: hsla(0, 0%, 88%, 1);\n$clr-light-600: hsla(0, 0%, 92%, 1);\n$clr-light-700: hsla(0, 0%, 100%, 0.43);\n$clr-light-800: hsla(0, 0%, 98%, 0.83);\n$clr-light-850: hsla(0, 0%, 100%, 0.85);\n$clr-light-95: hsla(0, 0%, 95%, 1);\n$clr-light-900: hsla(0, 0%, 100%, 1);\n$clr-black: rgba(0, 0, 0, 1);\n$clr-black-900: hsla(217, 31%, 6%, 1);\n$clr-black-850: hsla(240, 50%, 4%, 0.69);\n$clr-black-500: hsla(217, 31%, 6%, 0.21);\n$clr-black-25: rgba(0, 0, 0, 0.25);\n$clr-dark-900: hsla(217, 24%, 17%, 1);\n$clr-dark-700: hsla(217, 24%, 17%, 0.788);\n$clr-dark-650: hsla(217, 24%, 17%, 0.35);\n$clr-dark-600: hsla(214, 4%, 39%, 1);\n$clr-dark-630: hsla(214, 4%, 39%, 0.63);\n$clr-dark-500: hsla(217, 1%, 50%, 1);\n$clr-dark-450: hsla(210, 1%, 50%, 1);\n$clr-dark-400: hsla(0, 0%, 97%, 0.78);\n$clr-dark-350: hsla(240, 22%, 95%, 0.22);\n$clr-link-900: hsla(240, 91%, 69%, 1);\n$clr-link-700: hsla(240, 91%, 69%, 1);\n$clr-success-400: hsla(113, 49%, 55%, 0.34);\n\n$clr-dark-300: hsla(214, 4%, 31%, 1);\n$clr-dark-250: hsla(180, 20%, 17%, 1);\n$clr-dark-200: hsla(223, 4%, 66%, 1);\n$clr-dark-150: hsla(217, 24%, 17%, 0.79);\n$clr-light-10: hsla(0, 0%, 71%, 1);\n$clr-light-15: hsla(0, 0%, 92%, 0.69);\n$clr-light-20: hsla(214, 4%, 31%, 0.8);\n$clr-light-25: hsla(0, 0%, 77%, 1);\n$clr-light-30: hsla(0, 0%, 98%, 1);\n$clr-light-35: hsla(0, 0%, 75%, 0.28);\n$clr-light-40: hsla(214, 4%, 31%, 0.79);\n$clr-primary-10: hsla(234, 95%, 92%, 0.37);\n$clr-primary-20: hsla(234, 95%, 92%, 1);\n$clr-link-600: hsla(234, 92%, 56%, 1);\n$clr-success: hsla(217, 24%, 17%, 0.93);\n$clr-table: hsla(213, 7%, 76%, 0.08);\n\n\n\n\nhtml,\nbody {\n  height: 100%;\n}\n\n@for $i from 1 through 100 {\n  $size: 1px * $i;\n\n  .font-size-#{$i} {\n      font-size: $size !important;\n  }\n}\n\nbody {\n  margin: 0;\n  font-family: 'roboto' !important;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: $clr-light-600 !important;\n  color: $clr-dark-900 !important;\n}\n\na {\n  color: $clr-link-700;\n\n  &:hover,\n  &:focus {\n    color: $clr-link-900;\n  }\n\n  &.no-underline {\n    text-decoration: none;\n  }\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}","@import '../../../index.scss';\n\n.gate__menu {\n    .MuiPaper-root {\n        border-radius: 5px;\n        box-shadow: 0px 2px 2px rgba(76, 79, 83, 0.14);\n        box-sizing: border-box;\n        margin-top: -8px;\n        margin-left: 10px;\n    }\n\n    .MuiList-root {\n        padding: 0 16px;\n        background: #F8F8F9;\n        border-radius: 5px;\n        \n        .MuiMenuItem-root {\n            color: $clr-dark-600;\n            font-size: 14px;\n            letter-spacing: 0.25px;\n            justify-content: center;\n            line-height: 1;\n            padding: 6px 0;\n            &:not(:last-child){\n                border-bottom: 1px solid rgba(196, 196, 196, 0.2);            \n            }\n        }\n    }\n}\n\n.gates__list {\n    margin-bottom: 32px;\n\n    &__header {\n        font-size: 18px;\n        font-weight: 900;\n        margin-bottom: 12px;\n        text-transform: capitalize;\n    }\n\n    &__body {\n        .table-responsive{\n            border-radius: 5px 5px 0 0;\n        }\n        // background-color: $clr-dark-350;\n        // border: 1px solid $clr-dark-350;\n        // border-radius: 4px;\n        // padding: 1em 0.9375em;\n        .pagination{\n            justify-content: center;\n            margin-top: 2rem;\n            .page-item{\n                margin: 0 4px;\n                &.active{\n                    a{\n                        color: #4C4F53\n                    }\n                }\n                .page-link{\n                    background: transparent;\n                    border: 0;\n                    padding: 4px 8px;\n                    color: #0d6efd;\n                    .rightPagination__arrow, .leftPagination__arrow{\n                        path{\n                            fill: #0d6efd;\n                        }\n                    }\n                }\n                &:first-child .page-link, &:last-child .page-link{\n                    background: #FDFDFD;\n                    border-radius: 5px;\n                }\n                &.disabled{\n                    .rightPagination__arrow, .leftPagination__arrow{\n                        path{\n                            fill: #EAEAEA;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    &__body-table {\n        margin-bottom: 0;\n\n        tr {\n            border-bottom: solid 0.2em $clr-table;\n        }\n\n        tbody {\n            tr:hover {\n                background-color: hsla(237, 69%, 40%, 0.06);\n            }\n        }\n        .body__header{\n            background: $clr-table;\n            border-radius: 5px 5px 0px 0px;\n        }\n        .table__body {\n            tr{\n                background: #FDFDFD;\n                border: 1px solid rgba(73, 68, 84, 0.06);\n            }\n            tr:nth-child(even){\n                background: #FAFAFA;\n                border: 1px solid rgba(73, 68, 84, 0.06);\n                &:hover{\n                    background-color: hsla(237, 69%, 40%, 0.06);\n                }\n            }\n            td{\n                padding-bottom: 17px;\n                padding-top: 17px;\n                height: 70px;\n            }\n        }\n    }\n\n    &__body-table-header {\n        padding: 19px 8px 16px !important;\n        font-weight: 400;\n        font-size: 14px;\n        letter-spacing: 0.15px;\n        color: $clr-dark-300;\n        border: none;\n\n        &:first-child {\n            padding-left: 44px !important;\n        }\n\n        &:last-child {\n            padding-left: 0;\n            padding-right: 0;\n        }\n    }\n\n    &__body-row {\n        font-size: 12px;\n        // color: white;\n        cursor: pointer;\n\n        &.draft td {\n            &:not(:last-of-type){\n                width: 10%;\n            }\n\n            &:first-child {\n                width: 60%;\n                word-break: break-all;\n            }\n            &:nth-of-type(5) {\n                width: 6%;\n            }\n            &:last-of-type{\n                width: 1%;\n            }\n\n            @media screen and (max-width: 1280px) {\n                width: 15%;\n\n                &:first-child {\n                    width: 60%;\n                }\n            }\n        }\n\n        &.running td {\n            &:not(:last-of-type){\n                width: 9.5%;\n            }\n\n            &:first-child {\n                width: 50%;\n                word-break: break-all;\n            }\n            &:nth-of-type(6) {\n                width: 8%;\n            }\n            &:last-of-type{\n                width: 1%;\n            }\n\n            @media screen and (max-width: 1280px) {\n                width: 15%;\n\n                &:first-child {\n                    width: 40%;\n                }\n            }\n        }\n\n        &.paused td,\n        &.archived td {\n            &:not(:last-of-type){\n                width: 9.5%;\n            }\n\n            &:first-child {\n                width: 50%;\n                word-break: break-all;\n            }\n            &:nth-of-type(6) {\n                width: 8%;\n            }\n            &:last-of-type{\n                width: 1%;\n            }\n\n            @media screen and (max-width: 1280px) {\n                width: 15%;\n\n                &:first-child {\n                    width: 40%;\n                }\n            }\n        }\n\n        &.all td {\n            &:not(:last-of-type){\n                width: 10%;\n            }\n\n            &:first-child {\n                width: 50%;\n                word-break: break-all;\n            }\n            &:nth-of-type(6) {\n                width: 6%;\n            }\n            &:last-of-type{\n                width: 1%;\n            }\n\n\n            @media screen and (max-width: 1280px) {\n                width: 15%;\n\n                &:first-child {\n                    width: 55%;\n                }\n            }\n        }\n\n        button svg {\n            color: #000;\n            height: 18px;\n        }\n    }\n\n    &__body-row td {\n        border: none;\n        vertical-align: middle;\n\n        .button_container {\n            display: flex;\n            align-items: center;\n            &.status_color{\n                font-weight: 700;\n                text-transform: capitalize;\n                color: rgba(73, 68, 84, 0.5);\n                word-break: inherit;\n            }\n            button{\n                padding: 14px;\n            }\n            p{\n                margin-bottom: 0;\n                font-size: 12px;\n                font-weight: 400;\n            }\n        }\n\n        &:first-child {\n            padding-left: 0;            \n        }\n\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
